import { ReportUrl } from "@common";
import { LocationChangeAction, LOCATION_CHANGE } from "react-router-redux";
import { Action } from "redux";
import { all, takeEvery } from "redux-saga/effects";
import { reportParametersForm } from "../state";
import {
    fillReportParametersFormFromUrlParams,
    updateReportUrlOnChangeReportParams,
    uploadMappings
} from "./report-parameters-form";
import { loadCampaignList } from "./load-report-common-data";
import { loadReportingData } from "./load-report-chart-data";

export function* reportSaga() {
    yield all([
        takeEvery(
            (a: LocationChangeAction) => a.type === LOCATION_CHANGE && ReportUrl.match(a.payload, true).isMatched,
            function*(action: LocationChangeAction) {
                yield* loadCampaignList(action);
                yield* fillReportParametersFormFromUrlParams(action);
                yield* loadReportingData(action);
                yield* uploadMappings(action);
            }
        ),
        takeEvery((a: Action) => reportParametersForm.actions.isValidate(a), updateReportUrlOnChangeReportParams)
    ]);
}
